export const P00037ConsigneManuel = [
  { label: '30 %', ref: 30 },
  { label: '40 %', ref: 40 },
  { label: '50 %', ref: 50 },
  { label: '60 %', ref: 60 },
  { label: '70 %', ref: 70 },
  { label: '80 %', ref: 80 },
  { label: '90 %', ref: 90 },
  { label: '100 %', ref: 100 },
];
